import React, { FunctionComponent, useEffect, } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as TimesIcon } from '../../assets/icons/times.svg'

import {
  Button,
} from '@mui/material'

import './Wizard.css';
import { Origin } from '../../App/app';

interface Props {
  origin: Origin,
  onBack: () => void,
}

const Wizard: FunctionComponent<Props> = ( props ) => {

  const { t } = useTranslation( [ 'wizard' ] );

  // We need to remove the reactivity by using useEffect
  // that way after clicking the button the component will stay in the DOM
  // while the redirection is happening
  const [ open, setOpen ] = React.useState( false );
  useEffect( () => {
    if ( props.origin ) {
      setOpen( true );
    }
  }, [] );

  const onClick = () => {
    props.onBack();
  }

  return ( open ?
    <div className="wizard">
        <div className="wizard__body">
          <Button
            onClick={ onClick }
            variant="outlined"
            color="secondary"
          >
            { t( 'close' ) }
            <TimesIcon />
          </Button>
        </div>
    </div>
    : <></>
  );
}

export default Wizard;
